import { MessageCircle } from "lucide-react";
import { CLINIC } from "@/data/content";

export default function WhatsAppButton() {
  const url = `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(CLINIC.whatsappMsg)}`;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      data-testid="whatsapp-float-button" aria-label="Scrie-ne pe WhatsApp"
      className="fixed z-50 right-4 bottom-24 lg:bottom-6 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl shadow-[#25D366]/40 hover:scale-105 active:scale-95 transition-transform">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <MessageCircle className="w-7 h-7 relative" fill="white" strokeWidth={0} />
    </a>
  );
}
